import React from 'react';
import { TeamRole, Person } from 'nekst-api';

export default function TeamRoleField(
  props: { person: Person },
) {
  let label;
  switch (props.person.teamRole) {
    case undefined:
    case null:
    case TeamRole.CONTACT:
      label = 'Contact';
      break;
    case TeamRole.ADMINISTRATOR:
      label = 'Team Administrator';
      break;
    case TeamRole.OWNER:
      label = 'Team Owner';
      break;
    case TeamRole.MEMBER:
      label = 'Team Member';
      break;
    case TeamRole.INVITED_USER:
      label = 'Invited User';
      break;
    default:
      label = '';
  }

  if (props.person._serviceProviders.length > 0) {
    label = 'Service Provider';
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{label}</>
  );
}
